"use client";
import React, { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/apiConfig";

const TaskProgressContext = createContext();

export const TaskProgressProvider = ({ children }) => {
  const [taskProgress, setTaskProgress] = useState({
    progress: [],
    status_history: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Safe JSON parser
  const parseJson = async (response) => {
    try {
      return await response.json();
    } catch {
      return null;
    }
  };

  // 🔹 Add Task Progress
  const addTaskProgress = async (progressForm) => {
    if (!progressForm.task_id || !progressForm.completed_hours) {
      return {
        success: false,
        status: 400,
        message: "Task and hours are required",
      };
    }

    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${BASE_URL}/task-progress`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(progressForm),
      });

      const data = await parseJson(res);

      if (!res.ok || !data) {
        return {
          success: false,
          status: res.status,
          message: data?.message || "Failed to add task progress",
        };
      }

      return {
        success: true,
        ...data,
      };
    } catch (err) {
      console.error(err);
      return {
        success: false,
        status: 500,
        message: "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  // 🔹 View Progress History by Task ID
  const getTaskProgressByTask = async (taskId) => {
    if (!taskId) {
      return {
        success: false,
        status: 400,
        message: "Task ID is required",
      };
    }

    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${BASE_URL}/task-progress/${taskId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await parseJson(res);

      if (res.ok && data?.status === 200) {
        setTaskProgress({
          progress: data.data?.progress || [],
          status_history: data.data?.status_history || [],
        });
      } else {
        setError(data?.message || "Failed to fetch progress");
      }

      return data || {
        success: false,
        status: res.status,
        message: "Invalid server response",
      };
    } catch (err) {
      console.error(err);
      setError("Failed to fetch progress");

      return {
        success: false,
        status: 500,
        message: "Failed to fetch progress",
      };
    } finally {
      setLoading(false);
    }
  };

  return (
    <TaskProgressContext.Provider
      value={{
        taskProgress,
        loading,
        error,
        addTaskProgress,
        getTaskProgressByTask,
        setTaskProgress,
      }}
    >
      {children}
    </TaskProgressContext.Provider>
  );
};

// 🔹 Custom hook
export const useTaskProgress = () => useContext(TaskProgressContext);